import { render, staticRenderFns } from "./EcommerceChangeCard.vue?vue&type=template&id=d61de822&"
import script from "./EcommerceChangeCard.vue?vue&type=script&lang=js&"
export * from "./EcommerceChangeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports